import { CustomerRoles } from '@/entities/api/roles'
import { UsersPositions } from '@/entities/api/users/users'

export const roleConvert = (role: UsersPositions) => {
	switch (role) {
		case 'administration':
			return 'Administrador'
		case 'support_manager':
			return 'Soporte'
		case 'stock_manager':
			return 'Inventario'
		default:
			return 'Sin cargo'
	}
}

export const roleCustomerConvert = (role: CustomerRoles) => {
	switch (role) {
		case 'customer':
			return 'Cliente'
		default:
			return 'Sin cargo'
	}
}
